<irb-dropdown-filter
  #IrbDropdownFilter
  [(value)]="irbDropdownFilterValue"
  (search)="getItemsForFilter($event)"
  (selection)="onOptionChange()"
></irb-dropdown-filter>
